import Apollo from '@/graphql/vue-apollo'
import Loader from '@/services/loader'

import gql from 'graphql-tag'

const EXPORT_STUDY_PROGRAM_PIPELINE_STEP = gql`
  mutation ExportStudyProgramPipelineStep($input: ExportStudyProgramPipelineStepInput!) {
    exportStudyProgramPipelineStep(input: $input) {
      downloadUrl
    }
  }
`
const CHANGE_STUDY_PROGRAM_APPLICATION_POSTING = gql`
  mutation ChangeStudyProgramApplicationPosting($input: ChangeStudyProgramApplicationsPostingInput!) {
    changeStudyProgramApplicationPosting(input: $input) {
      studyProgramApplications {
        id
      }
    }
  }
`
const CHANGE_STUDY_PROGRAM_APPLICATION_POSTING_WITH_FILTERS = gql`
  mutation ChangeStudyProgramApplicationPostingWithFilters($input: ChangeStudyProgramApplicationsPostingWithFiltersInput!) {
    changeStudyProgramApplicationPostingWithFilters(input: $input) {
      studyProgramApplications {
        id
      }
    }
  }
`
const UPDATE_CANDIDATE_STUDY_PROGRAM_APPLICATION_STEP_WITH_FILTERS = gql`
  mutation UpdateCandidateStudyProgramApplicationStepWithFilters(
    $input: SetStudyProgramApplicationsPipelineStepWithFiltersInput!
  ) {
    setStudyProgramApplicationsPipelineStepWithFilters(input: $input) {
      studyProgramApplications {
        id
        currentStep
        possibleNextSteps
      }
    }
  }
`
const UPDATE_CANDIDATE_STUDY_PROGRAM_APPLICATION_STEP = gql`
  mutation UpdateCandidateStudyProgramApplicationStep($input: SetStudyProgramApplicationsPipelineStepInput!) {
    setStudyProgramApplicationsPipelineStep(input: $input) {
      studyProgramApplications {
        id
        currentStep
        possibleNextSteps
      }
    }
  }
`
const GET_STUDY_PROGRAM_PIPELINE = gql`
  query GetStudyProgramPipeline(
    $studyProgramPostingId: ID!
    $page: Int!
    $limit: Int!
    $sortLanguage: ContentLanguage!
    $sortField: StudyProgramApplicationSortField
    $filters: StudyProgramApplicationFiltersInput
  ) {
    studyProgramPosting(id: $studyProgramPostingId) {
      id
      institution {
        id
        name
      }
      mission {
        id
        pipelineAutomationsDisabled
        convocationStartDate
      }
      publishedVersion {
        id
        translationOrDefault(language: $sortLanguage) {
          id
          title
        }
      }
      pipeline {
        id
        stats {
          steps {
            applicationCount
            step
          }
        }
        batchTransitions {
          from
          to
        }
        applications(page: $page, limit: $limit, sortField: $sortField, filters: $filters, sortLanguage: $sortLanguage) {
          results {
            items {
              id
            }
          }
          facets {
            country {
              count
              label
              value
            }
            nationalities {
              count
              label
              value
            }
            frenchLevel {
              count
              value
            }
            englishLevel {
              count
              value
            }
            interviewLocation {
              count
              value
            }
            step {
              count
              value
            }
            secondaryStudyProgramPosting {
              count
              label
              value
            }
            agenda {
              count
              label
              value
            }
            ageGroup {
              count
              value
            }
            educationLevel {
              count
              value
            }
            trainingLevel {
              count
              value
            }
            currentStudyProgramLevel {
              count
              value
            }
            hasReportsAndDiplomasCopy {
              count
              value
            }
            tuitionFeesAbleToPay {
              count
              value
            }
            studyExpensesPayer {
              count
              value
            }
            hasFirstStudyYearLivingExpensesFinancialResources {
              count
              value
            }
            livingExpensesPayer {
              count
              value
            }
            financialResourcesProofs {
              count
              value
            }
            hasInfraction {
              count
              value
            }
            hasEntryRefused {
              count
              value
            }
            hasPassport {
              count
              value
            }
          }
        }
      }
    }
  }
`

export default {
  getPipeline: async function(variables) {
    let result = {}
    let response = null
    variables.page = 1
    Loader.modifyCount(1)

    response = await Apollo.instance.defaultClient.query({
      query: GET_STUDY_PROGRAM_PIPELINE,
      variables,
      fetchPolicy: 'network-only'
    })
    result = response.data
    //result.studyProgramPosting.pipeline.applications.results.items = []

    Loader.modifyCount(-1)
    return result
  },
  setApplicationsPipelineStep: async function(candidateIds, studyProgramPostingId, newStep) {
    let response = await Apollo.instance.defaultClient.mutate({
      mutation: UPDATE_CANDIDATE_STUDY_PROGRAM_APPLICATION_STEP,
      variables: {
        input: {
          candidateIds,
          studyProgramPostingId,
          newStep
        }
      }
    })

    return response.data.setStudyProgramApplicationsPipelineStep.studyProgramApplications
  },
  setApplicationsPipelineStepWithFilters: async function(filter, studyProgramPostingId, newStep) {
    let response = await Apollo.instance.defaultClient.mutate({
      mutation: UPDATE_CANDIDATE_STUDY_PROGRAM_APPLICATION_STEP_WITH_FILTERS,
      variables: {
        input: {
          filter,
          studyProgramPostingId,
          newStep
        }
      }
    })

    return response.data.setStudyProgramApplicationsPipelineStepWithFilters.studyProgramApplications
  },
  changeApplicationPosting: async function(applicationIds, newPostingId) {
    let input = {
      applicationIds,
      newPostingId
    }

    let result = await Apollo.instance.defaultClient.mutate({
      mutation: CHANGE_STUDY_PROGRAM_APPLICATION_POSTING,
      variables: {
        input
      }
    })
    return result
  },
  changeApplicationPostingWithFilters: async function(filter, studyProgramPostingId, newPostingId) {
    let input = {
      filter,
      studyProgramPostingId,
      newPostingId
    }

    let result = await Apollo.instance.defaultClient.mutate({
      mutation: CHANGE_STUDY_PROGRAM_APPLICATION_POSTING_WITH_FILTERS,
      variables: {
        input
      }
    })
    return result
  },
  exportPipelineStep: async function(studyProgramPostingId, step) {
    let input = {
      studyProgramPostingId,
      step
    }

    let result = await Apollo.instance.defaultClient.mutate({
      mutation: EXPORT_STUDY_PROGRAM_PIPELINE_STEP,
      variables: {
        input
      }
    })

    return result.data.exportStudyProgramPipelineStep
  }
}
